import { useRef, useEffect } from "react";
import * as ReactDOM from "react-dom";
import { useActivityType } from "services/activityTypeService";

export const ActivityLoader = (props) => {
  const { data: activitiesList, loading } = useActivityType();
  const lastSuccess = useRef("");
  const pending = useRef("");

  useEffect(() => {
    if (activitiesList && activitiesList.length > 0) {
      lastSuccess.current = pending.current;
      pending.current = "";

      props.onDataReceived(activitiesList);
    }
  }, [activitiesList, loading, props.dataState, lastSuccess]);

  return pending.current || loading ? <LoadingPanel /> : null;
};

const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");

  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};
